import { supabase } from './supabase';
import { listTodosCore, createTodoCore, updateTodoCore, deleteTodoCore } from '@gv/core';

export interface TodoItem {
    id: string;
    user_id: string;
    title: string;
    description?: string | null;
    location?: string | null;
    due_date: string | null; // ISO or null
    done: boolean;
    contact_id?: string | null;
    event_id?: string | null;
    assigned_contact_id?: string | null;
    group_id?: string | null;
    recurrence?: string | null; // 'daily', 'weekly', 'monthly', 'yearly'
    reminder_minutes?: number | null; // minutes before event
    created_at?: string;
    updated_at?: string;
}

function tableMissingMsg(err: any) {
    const msg = String(err?.message || err?.details || err);
    return /relation .*todos.* does not exist/i.test(msg) || /table .*todos.* does not exist/i.test(msg);
}

function missingColumnMsg(err: any, column: string) {
    const msg = String(err?.message || err?.details || err);
    // Example: Could not find the 'description' column of 'todos' in the schema cache
    return /Could not find the '.*' column of 'todos' in the schema cache/i.test(msg) && msg.includes(`'${column}'`);
}

export async function listTodos(userId: string, opts?: { includeCompleted?: boolean; from?: string; to?: string; groupId?: string | null; assignedContactId?: string | null; contactId?: string | null }) {
    try {
        if (typeof window !== 'undefined' && (window as any).GV_DEBUG) {
            console.log('[todos] listTodos', { userId, opts });
        }
        const rows = await listTodosCore(supabase as any, userId, opts);
        return rows as any as TodoItem[];
    } catch (e: any) {
        console.error('[todos] listTodos failed:', e?.message || e, { userId, opts });
        throw e;
    }
}

export async function createTodo(input: Omit<TodoItem, 'id' | 'created_at' | 'updated_at' | 'user_id'>, userId: string) {
    return (await createTodoCore(supabase as any, input as any, userId)) as any as TodoItem;
}

export async function updateTodo(id: string, patch: Partial<TodoItem>) {
    return (await updateTodoCore(supabase as any, id, patch as any)) as any as TodoItem;
}

export async function deleteTodo(id: string) {
    await deleteTodoCore(supabase as any, id);
}
